import { useFlags } from 'launchdarkly-react-client-sdk';

import { WarrantyExtensionBanner } from '@phoenix/team-m/my-tool-shed/frontend/shared/warranty-extension/warranty-extension-banner';
import { useWarrantyExtensionEntry } from '@phoenix/team-m/my-tool-shed/frontend/shared/warranty-extension/use-warranty-extension-entry';

export const WarrantyExtensionSection = () => {
  const { 'warranty-extension-banner': warrantyExtensionBannerEnabled } = useFlags();
  const { legalConditions } = useWarrantyExtensionEntry({ disabled: !warrantyExtensionBannerEnabled });

  return (
    warrantyExtensionBannerEnabled && (
      <WarrantyExtensionBanner legalConditions={legalConditions} hasLinkButton={true} preffix="dashboard" trackEvents={true} />
    )
  );
};
